module.exports = __webpack_public_path__ + "img/morning-routine.4080b94f.webp";